module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/gastos/gastos-modal/gastos-modal.component.scss
// module id = ./src/app/gastos/gastos-modal/gastos-modal.component.scss
// module chunks = main